"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSubmitButton = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const defaultStyles = (theme) => ({
    root: {
        padding: theme.spacing.unit * 2,
    },
    button: {},
});
const FormSubmitButton = (props) => {
    const { handleSubmit, isSubmitting } = formik_1.useFormikContext();
    const { styles: _styles } = props, rest = tslib_1.__rest(props, ["styles"]);
    const styles = core_1.useStyles('FormSubmitButton', props, defaultStyles);
    return (react_1.default.createElement(components_1.View, { style: styles.root },
        react_1.default.createElement(components_1.Button, Object.assign({ style: styles.button, disabled: isSubmitting, loading: isSubmitting }, rest, { onPress: handleSubmit, type: "submit" }))));
};
exports.FormSubmitButton = FormSubmitButton;
exports.FormSubmitButton.defaultProps = {
    color: 'primary',
    name: 'submit',
    title: 'Submit',
    variant: 'contained',
};
